<template>
  <footer
    v-show="show"
    class="footer">
    <nav
      class="footer__nav"
      :class="{
        'footer__nav--first': active === 0,
        'footer__nav--last': active === pages.length - 1,
        'footer__nav--margin': active > 0 && active < pages.length - 1
      }">
      <div
        v-if="active > 0"
        class="footer__nav-item footer__nav-item--prev">
        <!-- <p>Back to</p> -->
        <button @click="goToPage(pages[active - 1])">
          <h3 v-html="pages[active - 1].name"></h3>
        </button>
      </div>

      <div
        v-if="active < pages.length - 1"
        class="footer__nav-item footer__nav-item--next">
        <button @click="goToPage(pages[active + 1])">
          <h3 v-html="pages[active + 1].name"></h3>
        </button>
      </div>
    </nav>
    <div
      v-if="footer"
      class="footer__bottom">
      <div class="footer__bottom-row">
        <div
          v-for="(col, key) in footer.cols"
          :key="`col${key}`"
          :class="[
            'footer__col',
            `footer__col--${(key + 1)}`
          ]"
          v-html="col.content">
        </div>
      </div>
      <div class="footer__bottom-row footer__bottom-row--subscribe">
        <Newsletter :note="footer.newsletter" />
      </div>
      <div class="footer__bottom-row footer__bottom-row--acknowledgement">
        <p
          class="note"
          v-html="footer.acknowledgement"></p>
      </div>
    </div>
  </footer>
</template>

<script>
import Newsletter from '@/components/Newsletter'
export default {
  name: 'Footer',
  components: {
    Newsletter
  },
  props: {
    pages: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      active: 0,
      show: false,
      footer: null
    }
  },
  async created() {
    this.active = this.getActivePage(this.$route.path)

    this.footer = await this.getFooter()

    setTimeout(() => {
      this.show = true
    }, 1200)
  },
  watch: {
    '$route.path': function(newPath, oldPath) {
      if (newPath !== oldPath) {
        this.show = false

        this.active = this.getActivePage(newPath)
        setTimeout(() => {
          this.show = true
        }, 1200)
      }
    },
  },
  methods: {
    getActivePage(path) {
      return this.pages.findIndex(page => {
        return page.link === path
      })
    },
    getFooter() {
      const url = `${process.env.VUE_APP_API_ADDRESS}/site/footer`

      return new Promise(resolve => {
        fetch(url, {
          headers: this.$headers
        })
          .then(response => response.json())
          .then(result => resolve(result))
      })
    },
    goToPage(page) {
      this.$router.push(page.link)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width:100%;
  margin: 80px auto 0 auto;

  &__nav {
    width: 100%;
    padding: #{$padding * 2} 0;
    border-top: 3px solid $black;
    border-bottom: 3px solid $black;
    display: flex;
    justify-content: space-between;

    &--first {
      justify-content: flex-end;
    }

    &--last {
      justify-content: flex-start;
    }

    &-item {
      // min-width: 20%;
      padding: 0 $page-padding;
      display: flex;
      flex-direction: column;

      button {
        @include button_resets;
        color: $black;
        border-color: $black;
        padding: 10px 24px;
        border: 3px solid $black;
        &:hover {
          color: $white;
          background-color: $black;
        }
      }

      &--next {
        align-items: flex-end;
        float: right;
      }

      &--prev {
        float: left;
        align-items: flex-start;
      }
    }
  }

  &__bottom {
    padding: $page-padding;
    background-color: $green;
    display: flex;
    flex-direction: column;

    &-row {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .footer__col {
        //width: calc(33% - #{$padding * 2 / 3});
        margin: 0 $padding $padding 0;

        &:nth-child(3n + 3) {
          margin-right: 0px;
        }

        /deep/ p {
          a {
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      &--acknowledgement {
        margin: 0px;
      }
    }
  }

  @media screen and (max-width: $mobile) {
    // flex-direction: column-reverse;
    // justify-content: center;
    // padding: $padding $mobile-padding;

    &__nav {
      padding: $padding 0;
      flex-direction: column;

      &--margin {
        .footer__nav-item--prev {
          margin-bottom: #{$padding / 2};
        }
      }

      &-item {
        margin: 0;
        padding: 0 $mobile-padding;
        width: 100%;

        button {
          width: 100%;
          padding: 10px 20px;
          text-transform: uppercase;
          h3 {
            font-size: $body--m;
          }
        }

        &:hover {
          &:after {
            color: #fff;
          }
        }

        &--prev {
          position: relative;
          &:after {
            content: '▼';// '◀';
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%) rotate(90deg);
            font-size: calc(#{$body} + 4px);
          }
        }

        &--next {
          position: relative;
          &:after {
            content: '▼';// '◀';
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%) rotate(-90deg);
            font-size: calc(#{$body} + 4px);
          }
        }
      }
    }

    &__bottom {
      padding: $padding $mobile-padding;

      &-row {
        .footer__col {
          width: 100%;
          margin: 0 0 $padding 0;

          a {
            font-size: $body--m;
          }
        }
      }
    }
  }
}
</style>
